
import React, { useState } from "react";
import { FaPhoneAlt, FaMapMarkerAlt, FaEnvelope } from "react-icons/fa";
import contactimg from "../Assessts/Contact6.jpg";
import emailjs from "emailjs-com";

const Contactpage = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    enquiry: "",
    contact: "",
    organization: "",
    country: "",
    message: "",
  });

  const [alertMsg, setAlertMsg] = useState("");
  const [showAlert, setShowAlert] = useState(false);

  // ✅ your EmailJS credentials
  const SERVICE_ID = "service_ly2d1yf"; // replace with your Service ID
  const TEMPLATE_ID = "template_3rd36ie"; // replace with your Template ID
  const PUBLIC_KEY = "O3D5TsbDxNjG5nQcD"; // replace with your Public Key

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // send email using EmailJS
    emailjs
      .send(SERVICE_ID, TEMPLATE_ID, formData, PUBLIC_KEY)
      .then(() => {
        setAlertMsg("✅ Enquiry submitted successfully! We'll contact you soon.");
        setShowAlert(true);
        setFormData({
          name: "",
          email: "",
          enquiry: "",
          contact: "",
          organization: "",
          country: "",
          message: "",
        });
      })
      .catch((error) => {
        console.error("Email sending error:", error);
        setAlertMsg("❌ Failed to send email. Please try again later.");
        setShowAlert(true);
      });

    setTimeout(() => setShowAlert(false), 5000);
  };

  return (
    <div>
      {/* Hero Section */}
      <div
        style={{
          position: "relative",
          width: "100%",
          height: "400px",
          overflow: "hidden",
        }}
      >
        <img
          src={contactimg}
          alt="Contact Us"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            filter: "brightness(60%)",
          }}
        />
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            color: "#fff",
            textAlign: "center",
          }}
        >
          <h1 style={{ fontSize: "48px", fontWeight: "bold" }}>Contact Us</h1>
          <p>
            <span style={{ color: "#fff" }}>Home</span>{" "}
            <span style={{ color: "skyblue" }}>/ Contact Us</span>
          </p>
        </div>
      </div>

      {/* Alert */}
      <div
        style={{
          position: "fixed",
          top: showAlert ? "20px" : "-60px",
          left: "50%",
          transform: "translateX(-50%)",
          backgroundColor: "#d4edda",
          color: "#155724",
          padding: "15px 30px",
          fontWeight: "bold",
          borderRadius: "5px",
          transition: "top 0.5s ease-in-out",
          zIndex: 1000,
        }}
      >
        {alertMsg}
      </div>

      {/* Reach Us Section */}
      <div style={{ textAlign: "center", padding: "60px 20px" }}>
        <h2 style={{ fontSize: "32px", fontWeight: "bold" }}>
          <span style={{ color: "#074f86ff" }}>Reach Us</span>
        </h2>
        <p
          style={{
            marginTop: "20px",
            maxWidth: "800px",
            margin: "0 auto",
            lineHeight: "1.8",
            fontSize: "16px",
            color: "#333",
          }}
        >
          To learn more about our service offerings and industry expertise or to
          have a Consulting professional contact you directly, please fill out
          the form below or submit an email.
        </p>
      </div>

      {/* Info Section */}
      <div
        style={{
          backgroundColor: "#155382ff",
          color: "#fff",
          display: "flex",
          justifyContent: "space-around",
          alignItems: "center",
          padding: "40px 20px",
          flexWrap: "wrap",
        }}
      >
        <div style={{ textAlign: "center", flex: "1", minWidth: "250px" }}>
          <FaPhoneAlt size={40} />
          <h3 style={{ marginTop: "10px", fontWeight: "bold" }}>CALL US</h3>
          <p>+91-9235352625 | +91-8595051974</p>
        </div>

        <div
          style={{
            width: "2px",
            backgroundColor: "#fff",
            height: "80px",
            margin: "0 20px",
          }}
        />

        <div style={{ textAlign: "center", flex: "1", minWidth: "250px" }}>
          <FaMapMarkerAlt size={40} />
          <h3 style={{ marginTop: "10px", fontWeight: "bold" }}>ADDRESS</h3>
          <b>Corporate Address:</b> 11B, 9th Floor, Urbtech NPX, Sector 153, Noida,
          U.P.201310
          <p>
            <b>Registered Office:</b> 419, Eldeco Udyan – 1, Behind Bangla
            Bazar, Lucknow 226002
          </p>
        </div>

        <div
          style={{
            width: "2px",
            backgroundColor: "#fff",
            height: "80px",
            margin: "0 20px",
          }}
        />

        <div style={{ textAlign: "center", flex: "1", minWidth: "250px" }}>
          <FaEnvelope size={40} />
          <h3 style={{ marginTop: "10px", fontWeight: "bold" }}>EMAIL ID</h3>
          <p>
            info@taadpl.com ,<br /> sales@taadpl.com
          </p>
        </div>
      </div>

      {/* Enquiry Form */}
      <div style={{ textAlign: "center", padding: "60px 20px" }}>
        <h2 style={{ fontSize: "28px", fontWeight: "bold", marginBottom: "20px" }}>
          <span style={{ color: "#074f86ff" }}>Enquiry Form</span>
        </h2>
        <form
          onSubmit={handleSubmit}
          style={{
            maxWidth: "600px",
            margin: "0 auto",
            display: "flex",
            flexDirection: "column",
            gap: "15px",
          }}
        >
          {Object.keys(formData).map((key) =>
            key === "enquiry" ? (
              <select
                key={key}
                name={key}
                value={formData[key]}
                onChange={handleChange}
                required
                style={{
                  padding: "12px",
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                  fontSize: "16px",
                }}
              >
                <option value="">Select Enquiry</option>
                <option value="sales">For Sales</option>
                <option value="support">For Support</option>
                <option value="other">Other</option>
              </select>
            ) : key === "message" ? (
              <textarea
                key={key}
                name={key}
                placeholder="Your Message (optional)"
                value={formData[key]}
                onChange={handleChange}
                rows="5"
                style={{
                  padding: "12px",
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                  fontSize: "16px",
                }}
              />
            ) : (
              <input
                key={key}
                type={key === "email" ? "email" : "text"}
                name={key}
                placeholder={
                  key.charAt(0).toUpperCase() + key.slice(1).replace("_", " ")
                }
                value={formData[key]}
                onChange={handleChange}
                required={["name", "email", "contact", "enquiry"].includes(key)}
                style={{
                  padding: "12px",
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                  fontSize: "16px",
                }}
              />
            )
          )}

          <button
            type="submit"
            style={{
              padding: "12px",
              backgroundColor: "#074f86ff",
              color: "#fff",
              fontSize: "16px",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
            }}
          >
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

export default Contactpage;
